import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/vnimpex-logo.png")